import { Link as TanStackLink } from "@tanstack/react-router";
import type { ComponentPropsWithoutRef, ReactNode, Ref } from "react";

type LinkProps = Omit<
  ComponentPropsWithoutRef<typeof TanStackLink>,
  "to" | "children"
> & {
  href: string;
  children?: ReactNode;
  ref?: Ref<HTMLAnchorElement>;
};

export const Link = ({ href, ref, ...props }: LinkProps) => (
  <TanStackLink {...props} ref={ref} to={href as never} />
);
